const SHOW_NOTIFICATIONS_DRAWER = "SHOW_NOTIFICATIONS_DRAWER";
const HIDE_NOTIFICATIONS_DRAWER = "HIDE_NOTIFICATIONS_DRAWER";

const initialState = () => ({
  notificationsDrawer: false,
});

const state = initialState();

const mutations = {
  [SHOW_NOTIFICATIONS_DRAWER]: (state) => {
    state.notificationsDrawer = true;
  },
  [HIDE_NOTIFICATIONS_DRAWER]: (state) => {
    state.notificationsDrawer = false;
  },
};

const actions = {
  showNotificationsDrawer({ commit }) {
    commit(SHOW_NOTIFICATIONS_DRAWER);
  },
  hideNotificationsDrawer({ commit }) {
    commit(HIDE_NOTIFICATIONS_DRAWER);
  },
};

const getters = {
  isNotificationsDrawerShown(state) {
    return state.notificationsDrawer;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
